/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { ciphersSchema } from "./ciphersSchema.ts"
import { protectedProfileSchema } from "./protectedProfileSchema.ts"
import { publicProfileSchema } from "./publicProfileSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully fetch the user data.
 */
export const sync200Schema = z.object({
  get ciphers() {
    return ciphersSchema
  },
  get publicProfile() {
    return publicProfileSchema
  },
  get protectedProfile() {
    return protectedProfileSchema
  },
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const sync401Schema = APIErrorSchema

export const syncQueryResponseSchema = sync200Schema
